import styles from "@/styles/Services.module.scss";

import { structuredData } from '@/data/structuredData';
import { Col, Container, Row } from 'react-bootstrap';
import Image from 'next/image';
import { getStrapiMedia } from '@/utils/media';
import Link from 'next/link';
import dynamic from 'next/dynamic';
const CaseStudies = dynamic(() => import("@/components/CaseStudies"));
const Layout = dynamic(() => import("@/components/Layout"));
const StructuredData = dynamic(() => import("@/components/StructuredData"));
const Contact = dynamic(() => import("@/components/Contact"));
const Resource = dynamic(() => import("@/components/Resource"));
const WhyChoose = dynamic(() => import("@/components/WhyChoose"));
export default function L1TemplateI({ ServiceLevel1SEO,
  ServiceBanner,
  getImage,
  WhyCubetFor,
  attributes,
  OurServices,
  serviceLevels,
  refresh,
  Technologies,
  WhyChooseUs,
  Slug,
  Categories,
  width,
  userCountry,
  MainTitle
}: any) {

  const updatedL1Service1 = {
    ...structuredData.l1Service1,
    name: MainTitle,  // Dynamic title
    url: `${process.env.NEXT_PUBLIC_BASE_URL}/services/${Slug}/`,
    description: ServiceLevel1SEO?.MetaDescription,  // Dynamic description
    image: ServiceBanner?.Banner?.data?.attributes?.url,
    mainEntity: {
      ...structuredData.l1Service1.mainEntity,
      name: MainTitle,  // Dynamic mainEntity title
      serviceType: ServiceBanner?.Title,  // Dynamic serviceType
    }
  };
  const updatedL1Service2 = {
    ...structuredData.l1Service2,
    itemListElement: structuredData.l1Service2.itemListElement.map((item, index) => {
      if (index === 1) { // Position 2
        return {
          ...item,
          item: {
            ...item.item,
            "@id": `${process.env.NEXT_PUBLIC_BASE_URL}/services/${Slug}/`,
            name: MainTitle || "Default Service Title", // Dynamic title
          },
        };
      }
      return item;
    }),
  };
  return (

    <Layout
      title={ServiceLevel1SEO?.MetaTitle}
      description={ServiceLevel1SEO?.MetaDescription}
      ogTitle={ServiceLevel1SEO?.OGTitle}
      ogDescription={ServiceLevel1SEO?.OGDescription}
      footerType="banner"
      banner={true}
    >
      <StructuredData
        data={[updatedL1Service1, updatedL1Service2, structuredData.l1Service3]}
      />
      <div className={styles.services}>
        <div className="header">
          <Container className="d-flex justify-content-between align-items-center">
            <Row>
              <Col lg={6}>
                <div className="contents">
                  <h1
                    dangerouslySetInnerHTML={{
                      __html: ServiceBanner?.Title?.split(" ").join("<br/>"),
                    }}
                  />
                  <p className="mb-0">{ServiceBanner?.SubTitle}</p>
                </div>
              </Col>
              <Col lg={6}>
                {/* <Image
                        src={getStrapiMedia(ServiceBanner?.Banner)}
                        width={ServiceBanner?.Banner?.data?.attributes?.width}
                        height={ServiceBanner?.Banner?.data?.attributes?.height}
                        priority={true}
                        alt={
                          ServiceBanner?.Banner?.data?.attributes?.alternativeText ||
                          ServiceBanner?.Title
                        }
                        style={{ objectFit: 'cover', maxHeight: '65vh' }}
                        className='d-none d-lg-block img-fluid mb-5 mb-lg-0'
                      /> */}
                {getImage(ServiceBanner)}
              </Col>
            </Row>
          </Container>
        </div>
        <div className="middle-content">
          <Container>
            <Row>
              <Col md={10} lg={8} xl={6}>
                <h2 className="heading">{WhyCubetFor?.Title}</h2>
                <p className="mb-0 normal-text">{WhyCubetFor?.Description}</p>
                {WhyCubetFor?.Highlights?.length > 0 && (
                  <ul>
                    {attributes?.WhyCubetFor?.Highlights.map(
                      (item: any, index: number) => (
                        <>
                          <li key={index}>{item?.Title}</li>
                          {index !==
                            attributes?.WhyCubetFor?.Highlights?.length - 1 && (
                              <li>&nbsp;</li>
                            )}
                        </>
                      )
                    )}
                  </ul>
                )}
              </Col>
            </Row>
          </Container>
        </div>
        {OurServices?.ListInFrontEnd && (
          <div className="services">
            <Container>
              <Row>
                <Col xs={12}>
                  <h2 className="heading">{OurServices?.Title}</h2>
                </Col>
                {OurServices?.Collection.length > 0 &&
                  OurServices?.Collection.map((item: any) => (
                    <Col xs={6} lg={4} key={item.id}>
                      <div
                        className={item?.LinkUrl ? "box pointer" : "box"}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (e?.ctrlKey) window.open(item?.LinkUrl, "_blank");
                          else
                            item?.LinkUrl &&
                              window.location.assign(item?.LinkUrl);
                        }}
                      >
                        {/* <Image
                                src={getStrapiMedia(item?.Image)}
                                width={item.Image?.data?.attributes?.width}
                                height={item.Image?.data?.attributes?.height}
                                priority={false}
                                alt={
                                  item?.Image?.data?.attributes?.alternativeText ||
                                  item?.Title
                                }
                                style={{ objectFit: "contain" }}
                                className="img-fluid icon-img"
                              /> */}
                        <Image
                          src={getStrapiMedia(item?.Image)}
                          alt={
                            item?.Image?.data?.attributes?.alternativeText ||
                            item?.Title
                          }
                          width={item?.Image?.data?.attributes?.width}
                          height={item?.Image?.data?.attributes?.height}
                          style={{ objectFit: "contain" }}
                          className="img-fluid icon-img"
                        />
                        <h4>{item?.Title}</h4>
                        <p className="normal-text">{item?.ShortDescription}</p>
                        {item?.LinkUrl && (
                          <Link prefetch={false} href={item?.LinkUrl}>
                            Learn More{" "}
                            <Image
                              src="/assets/icons/green.svg"
                              width={61}
                              height={53}
                              priority={false}
                              alt="arrow"
                              style={{ objectFit: "cover" }}
                              className="img-fluid"
                            />
                          </Link>
                        )}
                      </div>
                    </Col>
                  ))}
              </Row>
            </Container>
          </div>
        )}
        <div className="case-lone">
          <CaseStudies
            categoryId={serviceLevels?.id}
            refresh={refresh}
            level={1}
          />
        </div>
        {Technologies?.DisplayInFrontned && (
          <div className="technologies">
            <Container>
              <Row className="align-items-center">
                <Col xs={12}>
                  <h5 className="heading text-center">{Technologies?.Title}</h5>
                  <p className="text-center">{Technologies?.SubTitle}</p>
                </Col>
                {Technologies?.Technologies?.data?.length > 0 && (
                  <Col xs={12}>
                    <ul className="first">
                      {Technologies?.Technologies?.data?.map(
                        (item: any, index: number) => (
                          <li key={index}>
                            {/* <Image
                                    src={item?.attributes?.url}
                                    width={item?.attributes?.width}
                                    height={item?.attributes?.height}
                                    priority={false}
                                    alt={
                                      item?.attributes?.alternativeText ||
                                      "technologies"
                                    }
                                    style={{ objectFit: "contain" }}
                                    className="img-fluid"
                                  /> */}
                            <Image
                              src={item?.attributes?.url}
                              alt={
                                item?.attributes?.alternativeText ||
                                "technologies"
                              }
                              style={{ objectFit: "contain" }}
                              className="img-fluid"
                              height={item?.attributes?.height}
                              width={item.attributes?.width}
                            />
                          </li>
                        )
                      )}
                    </ul>
                  </Col>
                )}
              </Row>
            </Container>
          </div>
        )}
        <WhyChoose data={WhyChooseUs} />

        <Resource slug={Slug} categories={Categories?.data} />
        <div className="contact-new">
          <Contact
            type="fixed"
            title="Contact Us"
            className={width <= 767 ? "without-over" : "without-over"}
            country={
              userCountry === "countryNotFound" ? null : userCountry || null
            }
          />
        </div>
      </div>
    </Layout>
  )
}
